module.exports = __webpack_public_path__ + "img/548.bf8def65.jpg";